import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Typography, Box, Paper, Button } from "@mui/material";
import { useSelector } from "react-redux";

const ViewAttendanceStats = () => {
  const { data: attendanceData } = useSelector((state) => state.attendenceSlice);

  // Transform the attendance data into a chart-friendly format
  const chartData = attendanceData?.data?.attendance?.map((record) => ({
    date: record.date,
    Present: record.present.length,
    Absent: record.absent.length,
  })) || [];

  // Generate and download attendance report as CSV
  const downloadReport = () => {
    const headers = "Date,Employee ID,Status\n";

    const rows = attendanceData?.data?.attendance
      ?.flatMap(({ date, present, absent }) => [
        ...present.map((id) => `${date},${id},Present`),
        ...absent.map((id) => `${date},${id},Absent`),
      ])
      .join("\n") || "";

    const csvContent = headers + rows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "AttendanceReport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  };

  return (
    <Paper
      sx={{
        padding: "24px",
        margin: "20px auto",
        maxWidth: "900px",
        borderRadius: "12px",
        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#ffffff",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          marginBottom: "20px",
          textAlign: "center",
          color: "#1a1a1a",
        }}
      >
        Attendance Statistics
      </Typography>

      <Box sx={{ height: "400px", marginBottom: "20px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip
              contentStyle={{ backgroundColor: "#f4f4f4", borderRadius: "8px" }}
              labelStyle={{ fontWeight: "bold" }}
            />
            <Legend
              wrapperStyle={{
                paddingTop: "10px",
                textAlign: "center",
              }}
            />
            <Bar
              dataKey="Present"
              fill="#4caf50"
              name="Present"
              barSize={50}
            />
            <Bar
              dataKey="Absent"
              fill="#f44336"
              name="Absent"
              barSize={50}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>

      <Box sx={{ textAlign: "center" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={downloadReport}
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            padding: "10px 20px",
          }}
        >
          Download Attendance Report
        </Button>
      </Box>
    </Paper>
  );
};

export default ViewAttendanceStats;
